import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "cs_cookie_consent";

export function openCookieSettings() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event("cs-cookie-reopen"));
}

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
    const reopen = () => setShow(true);
    window.addEventListener("cs-cookie-reopen", reopen);
    return () => window.removeEventListener("cs-cookie-reopen", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, date: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-20 md:bottom-4 inset-x-3 md:inset-x-auto md:right-4 md:max-w-md z-50 bg-white rounded-2xl shadow-[0_12px_40px_rgba(61,35,20,0.25)] border border-[#E6D7C3] p-5">
      <div className="flex items-center gap-2 text-[#2B170C] font-serif font-semibold mb-2"><Cookie size={18} className="text-[#A8410F]" /> Cookies</div>
      <p className="text-sm text-[#6E5544] leading-relaxed">
        Nous utilisons des cookies nécessaires au fonctionnement du site. Les cookies non essentiels ne sont déposés qu'avec votre accord. {" "}
        <Link to="/politique-cookies" className="text-[#A8410F] underline">En savoir plus</Link>.
      </p>
      <div className="flex gap-2 mt-4">
        <button data-testid="cookie-refuse" onClick={() => choose("refused")} className="flex-1 py-2.5 rounded-full border border-[#DCC6AE] text-[#2B170C] text-sm font-medium hover:bg-[#F3E6D3] transition-colors">Refuser</button>
        <button data-testid="cookie-accept" onClick={() => choose("accepted")} className="flex-1 btn-terra py-2.5 rounded-full text-sm font-semibold">Accepter</button>
      </div>
    </div>
  );
}
